import { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { changeRequestStatus, setPopChangeRequestStatus } from '../../store/api/ProductRequest';
import Loader from 'react-loader-spinner';
import { X } from 'react-bootstrap-icons';
const ModalChangeRequestStatus = ({ requestData, setRequestData, show, setShow, }) => {
    const status = useRef();
    const desc = useRef('');
    const { popup, statusList, commentList } = useSelector(state => {
        return {
            statusList: state.ProductRequestReducer.requestStatusList,
            commentList: state.ProductRequestReducer.productRequestComments
        }
    });
    const dispatch = useDispatch();
    const history = useHistory();
    const close = () => {
        setShow(false);
    }
    const changeStatus = () => {
        if (desc.current.value === '' || status.current.value === '') {
            return;
        }
        const selectedOption = status.current.options[status.current.selectedIndex];
        const comment = desc.current.value + "؛ وضعیت به << " + selectedOption.text + " >> تغییر کرد";
        const onSuccess = (item) => {
            setRequestData(prev => (
                {
                    ...prev,
                    StatusStr: selectedOption.text,
                    StatusCode: Number(selectedOption.getAttribute("code")),
                    LastComment: comment,
                    StatusCode: Number(status.current.value)
                }))
            if (!commentList) {
                commentList = [];
            }
            commentList.unshift(item);
            close();
        }

        dispatch(changeRequestStatus(requestData.ID, status.current.value, comment, onSuccess))

    }
    return (
        <Modal show={show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                تغییر وضعیت درخواست
                <span onClick={close} style={{ cursor: "pointer" }}><X size={20} /></span>
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <div className="row">
                    <div className="form-group">
                        <span style={{ color: "red", fontSize: "14px" }}>*&nbsp;</span><label>انتخاب وضعیت:</label>
                        {statusList === "PENDING" &&
                            <div className='form-control'>
                                <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                                <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری لیست وضعیت</span>
                            </div>
                        }
                        {statusList && Array.isArray(statusList) &&
                            <select className="form-control" ref={status} value={requestData.StatusId} onChange={e => setRequestData(prev => ({ ...prev, StatusId: Number(e.target.value) }))}>
                                {
                                    statusList.map((item, i) => { return (<option key={i} code={item.Code} value={item.ID}>{item.StatusName}</option>) })
                                }
                            </select>
                        }
                        <input type="text" className='form-control' ref={desc} placeholder='شرح وضعیت درخواست الزامی است' />
                    </div>
                </div>
                <Button className="btn-success mt-2" style={{ fontSize: "12px" }} onClick={changeStatus}>ثبت تغییرات</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalChangeRequestStatus;